<template>
    <div class="page-wrapper">

            <div class="content container-fluid">

                <div class="row">
                    <div class="col-md-12">
                        <div class="page-head-box">
                            <h3>Leads</h3>
                            <nav aria-label="breadcrumb">
                                <ol class="breadcrumb">
                                    <li class="breadcrumb-item"><a href="#">Dashboard</a></li>
                                    <li class="breadcrumb-item active" aria-current="page">Leads</li>
                                </ol>
                            </nav>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-12">
                        <div class="table-responsive">
                            <table class="table table-striped table-nowrap custom-table mb-0 datatable">
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>Lead Name</th>
                                        <th>Email</th>
                                        <th>Phone</th>
                                        <th>Project</th>
                                        <th>Assigned Staff</th>
                                        <th>Status</th>
                                        <th>Created</th>
                                        <th class="text-end">Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>01</td>
                                        <td>
                                            <h2 class="table-avatar">
                                                <a href="#" class="avatar"><img alt=""
                                                        src="assets/img/profiles/avatar-11.jpg"></a>
                                                <a href="#">Wilmer Deluna</a>
                                            </h2>
                                        </td>
                                        <td><a href="/cdn-cgi/l/email-protection" class="__cf_email__"
                                                data-cfemail="fa8d9396979f889e9f968f949bba9f829b978a969fd4999597">[email&#160;protected]</a>
                                        </td>
                                        <td>9876543210</td>
                                        <td><a href="project-view.html">Hospital Administration</a></td>
                                        <td>
                                            <ul class="team-members">
                                                <li>
                                                    <a href="#" title="John Doe" data-bs-toggle="tooltip"><img alt=""
                                                            src="assets/img/profiles/avatar-02.jpg"></a>
                                                </li>
                                                <li>
                                                    <a href="#" title="Richard Miles" data-bs-toggle="tooltip"><img
                                                            alt="" src="assets/img/profiles/avatar-09.jpg"></a>
                                                </li>
                                                <li class="dropdown avatar-dropdown">
                                                    <a href="#" class="all-users dropdown-toggle"
                                                        data-bs-toggle="dropdown" aria-expanded="false">+15</a>
                                                    <div class="dropdown-menu dropdown-menu-right">
                                                        <div class="avatar-group">
                                                            <a class="avatar avatar-xs" href="#">
                                                                <img alt="" src="assets/img/profiles/avatar-02.jpg">
                                                            </a>
                                                            <a class="avatar avatar-xs" href="#">
                                                                <img alt="" src="assets/img/profiles/avatar-09.jpg">
                                                            </a>
                                                            <a class="avatar avatar-xs" href="#">
                                                                <img alt="" src="assets/img/profiles/avatar-10.jpg">
                                                            </a>
                                                            <a class="avatar avatar-xs" href="#">
                                                                <img alt="" src="assets/img/profiles/avatar-05.jpg">
                                                            </a>
                                                            <a class="avatar avatar-xs" href="#">
                                                                <img alt="" src="assets/img/profiles/avatar-11.jpg">
                                                            </a>
                                                            <a class="avatar avatar-xs" href="#">
                                                                <img alt="" src="assets/img/profiles/avatar-12.jpg">
                                                            </a>
                                                            <a class="avatar avatar-xs" href="#">
                                                                <img alt="" src="assets/img/profiles/avatar-13.jpg">
                                                            </a>
                                                            <a class="avatar avatar-xs" href="#">
                                                                <img alt="" src="assets/img/profiles/avatar-01.jpg">
                                                            </a>
                                                            <a class="avatar avatar-xs" href="#">
                                                                <img alt="" src="assets/img/profiles/avatar-16.jpg">
                                                            </a>
                                                        </div>
                                                        <div class="avatar-pagination">
                                                            <ul class="pagination">
                                                                <li class="page-item">
                                                                    <a class="page-link" href="#" aria-label="Previous">
                                                                        <span aria-hidden="true">«</span>
                                                                        <span class="visually-hidden">Previous</span>
                                                                    </a>
                                                                </li>
                                                                <li class="page-item"><a class="page-link"
                                                                        href="#">1</a></li>
                                                                <li class="page-item"><a class="page-link"
                                                                        href="#">2</a></li>
                                                                <li class="page-item">
                                                                    <a class="page-link" href="#" aria-label="Next">
                                                                        <span aria-hidden="true">»</span>
                                                                        <span class="visually-hidden">Next</span>
                                                                    </a>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </li>
                                            </ul>
                                        </td>
                                        <td><span class="role-info role-bg-two">Working</span></td>
                                        <td>10 hours ago</td>
                                        <td class="text-end ico-sec">
                                            <a href="#"><i class="fas fa-pen"></i></a>
                                            <a href="#"><i class="far fa-trash-alt"></i></a>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>02</td>
                                        <td>
                                            <h2 class="table-avatar">
                                                <a href="#" class="avatar"><img alt=""
                                                        src="assets/img/profiles/avatar-01.jpg"></a>
                                                <a href="#">Lesley Grauer</a>
                                            </h2>
                                        </td>
                                        <td><a href="/cdn-cgi/l/email-protection" class="__cf_email__"
                                                data-cfemail="e18d84928d8498869380948493a18499808c918d84cf828e8c">[email&#160;protected]</a>
                                        </td>
                                        <td>9876543210</td>
                                        <td><a href="project-view.html">Video Calling App</a></td>
                                        <td>
                                            <ul class="team-members">
                                                <li>
                                                    <a href="#" title="John Doe" data-bs-toggle="tooltip"><img alt=""
                                                            src="assets/img/profiles/avatar-02.jpg"></a>
                                                </li>
                                                <li>
                                                    <a href="#" title="Richard Miles" data-bs-toggle="tooltip"><img
                                                            alt="" src="assets/img/profiles/avatar-09.jpg"></a>
                                                </li>
                                                <li>
                                                    <a href="#" class="all-users">+15</a>
                                                </li>
                                            </ul>
                                        </td>
                                        <td><span class="role-info role-bg-two">Working</span></td>
                                        <td>5 Mar 2019</td>
                                        <td class="text-end ico-sec">
                                            <a href="#"><i class="fas fa-pen"></i></a>
                                            <a href="#"><i class="far fa-trash-alt"></i></a>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>03</td>
                                        <td>
                                            <h2 class="table-avatar">
                                                <a href="#" class="avatar"><img alt=""
                                                        src="assets/img/profiles/avatar-16.jpg"></a>
                                                <a href="#">Jeffery Lalor</a>
                                            </h2>
                                        </td>
                                        <td><a href="/cdn-cgi/l/email-protection" class="__cf_email__"
                                                data-cfemail="bcd6d9dadad9cec5d0ddd0d3cefcd9c4ddd1ccd0d992dfd3d1">[email&#160;protected]</a>
                                        </td>
                                        <td>9876543210</td>
                                        <td><a href="project-view.html">Office Management</a></td>
                                        <td>
                                            <ul class="team-members">
                                                <li>
                                                    <a href="#" title="John Doe" data-bs-toggle="tooltip"><img alt=""
                                                            src="assets/img/profiles/avatar-02.jpg"></a>
                                                </li>
                                                <li>
                                                    <a href="#" title="Richard Miles" data-bs-toggle="tooltip"><img
                                                            alt="" src="assets/img/profiles/avatar-09.jpg"></a>
                                                </li>
                                                <li>
                                                    <a href="#" class="all-users">+15</a>
                                                </li>
                                            </ul>
                                        </td>
                                        <td><span class="role-info role-bg-two">Working</span></td>
                                        <td>27 Feb 2019</td>
                                        <td class="text-end ico-sec">
                                            <a href="#"><i class="fas fa-pen"></i></a>
                                            <a href="#"><i class="far fa-trash-alt"></i></a>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>04</td>
                                        <td>
                                            <h2 class="table-avatar">
                                                <a href="#" class="avatar"><img alt=""
                                                        src="assets/img/profiles/avatar-11.jpg"></a>
                                                <a href="#">Wilmer Deluna</a>
                                            </h2>
                                        </td>
                                        <td><a href="/cdn-cgi/l/email-protection" class="__cf_email__"
                                                data-cfemail="a7d0cecbcac2d5c3c2cbd2c9c6e7c2dfc6cad7cbc289c4c8ca">[email&#160;protected]</a>
                                        </td>
                                        <td>9876543210</td>
                                        <td><a href="project-view.html">Hospital Administration</a></td>
                                        <td>
                                            <ul class="team-members">
                                                <li>
                                                    <a href="#" title="John Doe" data-bs-toggle="tooltip"><img alt=""
                                                            src="assets/img/profiles/avatar-02.jpg"></a>
                                                </li>
                                                <li>
                                                    <a href="#" title="Richard Miles" data-bs-toggle="tooltip"><img
                                                            alt="" src="assets/img/profiles/avatar-09.jpg"></a>
                                                </li>
                                                <li>
                                                    <a href="#" class="all-users">+15</a>
                                                </li>
                                            </ul>
                                        </td>
                                        <td><span class="role-info role-bg-two">Working</span></td>
                                        <td>10 hours ago</td>
                                        <td class="text-end ico-sec">
                                            <a href="#"><i class="fas fa-pen"></i></a>
                                            <a href="#"><i class="far fa-trash-alt"></i></a>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>05</td>
                                        <td>
                                            <h2 class="table-avatar">
                                                <a href="#" class="avatar"><img alt=""
                                                        src="assets/img/profiles/avatar-01.jpg"></a>
                                                <a href="#">Lesley Grauer</a>
                                            </h2>
                                        </td>
                                        <td><a href="/cdn-cgi/l/email-protection" class="__cf_email__"
                                                data-cfemail="97fbf2e4fbf2eef0e5f6e2f2e5d7f2eff6fae7fbf2b9f4f8fa">[email&#160;protected]</a>
                                        </td>
                                        <td>9876543210</td>
                                        <td><a href="project-view.html">Video Calling App</a></td>
                                        <td>
                                            <ul class="team-members">
                                                <li>
                                                    <a href="#" title="John Doe" data-bs-toggle="tooltip"><img alt=""
                                                            src="assets/img/profiles/avatar-02.jpg"></a>
                                                </li>
                                                <li>
                                                    <a href="#" title="Richard Miles" data-bs-toggle="tooltip"><img
                                                            alt="" src="assets/img/profiles/avatar-09.jpg"></a>
                                                </li>
                                                <li>
                                                    <a href="#" class="all-users">+15</a>
                                                </li>
                                            </ul>
                                        </td>
                                        <td><span class="role-info role-bg-two">Working</span></td>
                                        <td>5 Mar 2019</td>
                                        <td class="text-end ico-sec">
                                            <a href="#"><i class="fas fa-pen"></i></a>
                                            <a href="#"><i class="far fa-trash-alt"></i></a>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>06</td>
                                        <td>
                                            <h2 class="table-avatar">
                                                <a href="#" class="avatar"><img alt=""
                                                        src="assets/img/profiles/avatar-16.jpg"></a>
                                                <a href="#">Jeffery Lalor</a>
                                            </h2>
                                        </td>
                                        <td><a href="/cdn-cgi/l/email-protection" class="__cf_email__"
                                                data-cfemail="650f00030300171c0904090a1725001d04081509004b060a08">[email&#160;protected]</a>
                                        </td>
                                        <td>9876543210</td>
                                        <td><a href="project-view.html">Office Management</a></td>
                                        <td>
                                            <ul class="team-members">
                                                <li>
                                                    <a href="#" title="John Doe" data-bs-toggle="tooltip"><img alt=""
                                                            src="assets/img/profiles/avatar-02.jpg"></a>
                                                </li>
                                                <li>
                                                    <a href="#" title="Richard Miles" data-bs-toggle="tooltip"><img
                                                            alt="" src="assets/img/profiles/avatar-09.jpg"></a>
                                                </li>
                                                <li>
                                                    <a href="#" class="all-users">+15</a>
                                                </li>
                                            </ul>
                                        </td>
                                        <td><span class="role-info role-bg-two">Working</span></td>
                                        <td>27 Feb 2019</td>
                                        <td class="text-end ico-sec">
                                            <a href="#"><i class="fas fa-pen"></i></a>
                                            <a href="#"><i class="far fa-trash-alt"></i></a>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>07</td>
                                        <td>
                                            <h2 class="table-avatar">
                                                <a href="#" class="avatar"><img alt=""
                                                        src="assets/img/profiles/avatar-11.jpg"></a>
                                                <a href="#">Wilmer Deluna</a>
                                            </h2>
                                        </td>
                                        <td><a href="/cdn-cgi/l/email-protection" class="__cf_email__"
                                                data-cfemail="bdcad4d1d0d8cfd9d8d1c8d3dcfdd8c5dcd0cdd1d893ded2d0">[email&#160;protected]</a>
                                        </td>
                                        <td>9876543210</td>
                                        <td><a href="project-view.html">Hospital Administration</a></td>
                                        <td>
                                            <ul class="team-members">
                                                <li>
                                                    <a href="#" title="John Doe" data-bs-toggle="tooltip"><img alt=""
                                                            src="assets/img/profiles/avatar-02.jpg"></a>
                                                </li>
                                                <li>
                                                    <a href="#" title="Richard Miles" data-bs-toggle="tooltip"><img
                                                            alt="" src="assets/img/profiles/avatar-09.jpg"></a>
                                                </li>
                                                <li>
                                                    <a href="#" class="all-users">+15</a>
                                                </li>
                                            </ul>
                                        </td>
                                        <td><span class="role-info role-bg-two">Working</span></td>
                                        <td>10 hours ago</td>
                                        <td class="text-end ico-sec">
                                            <a href="#"><i class="fas fa-pen"></i></a>
                                            <a href="#"><i class="far fa-trash-alt"></i></a>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>08</td>
                                        <td>
                                            <h2 class="table-avatar">
                                                <a href="#" class="avatar"><img alt=""
                                                        src="assets/img/profiles/avatar-01.jpg"></a>
                                                <a href="#">Lesley Grauer</a>
                                            </h2>
                                        </td>
                                        <td><a href="/cdn-cgi/l/email-protection" class="__cf_email__"
                                                data-cfemail="fb979e88979e829c899a8e9e89bb9e839a968b979ed5989496">[email&#160;protected]</a>
                                        </td>
                                        <td>9876543210</td>
                                        <td><a href="project-view.html">Video Calling App</a></td>
                                        <td>
                                            <ul class="team-members">
                                                <li>
                                                    <a href="#" title="John Doe" data-bs-toggle="tooltip"><img alt=""
                                                            src="assets/img/profiles/avatar-02.jpg"></a>
                                                </li>
                                                <li>
                                                    <a href="#" title="Richard Miles" data-bs-toggle="tooltip"><img
                                                            alt="" src="assets/img/profiles/avatar-09.jpg"></a>
                                                </li>
                                                <li>
                                                    <a href="#" class="all-users">+15</a>
                                                </li>
                                            </ul>
                                        </td>
                                        <td><span class="role-info role-bg-two">Working</span></td>
                                        <td>5 Mar 2019</td>
                                        <td class="text-end ico-sec">
                                            <a href="#"><i class="fas fa-pen"></i></a>
                                            <a href="#"><i class="far fa-trash-alt"></i></a>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>09</td>
                                        <td>
                                            <h2 class="table-avatar">
                                                <a href="#" class="avatar"><img alt=""
                                                        src="assets/img/profiles/avatar-16.jpg"></a>
                                                <a href="#">Jeffery Lalor</a>
                                            </h2>
                                        </td>
                                        <td><a href="/cdn-cgi/l/email-protection" class="__cf_email__"
                                                data-cfemail="cfa5aaa9a9aabdb6a3aea3a0bd8faab7aea2bfa3aae1aca0a2">[email&#160;protected]</a>
                                        </td>
                                        <td>9876543210</td>
                                        <td><a href="project-view.html">Office Management</a></td>
                                        <td>
                                            <ul class="team-members">
                                                <li>
                                                    <a href="#" title="John Doe" data-bs-toggle="tooltip"><img alt=""
                                                            src="assets/img/profiles/avatar-02.jpg"></a>
                                                </li>
                                                <li>
                                                    <a href="#" title="Richard Miles" data-bs-toggle="tooltip"><img
                                                            alt="" src="assets/img/profiles/avatar-09.jpg"></a>
                                                </li>
                                                <li>
                                                    <a href="#" class="all-users">+15</a>
                                                </li>
                                            </ul>
                                        </td>
                                        <td><span class="role-info role-bg-two">Working</span></td>
                                        <td>27 Feb 2019</td>
                                        <td class="text-end ico-sec">
                                            <a href="#"><i class="fas fa-pen"></i></a>
                                            <a href="#"><i class="far fa-trash-alt"></i></a>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>

        </div>
</template>

<script>
export default {
    data(){
        return{
        }
    },
    created() {
        document.getElementById("body").classList.remove("account-page");
    },
    methods:{
        login(){
            this.$router.push({path:"/dashboard"});
        }
    }
}
</script>
